import React, { useState, useEffect } from "react";

import { Dialog, DialogActions, DialogContent, DialogTitle,
  Slide, Table, TableBody,
  TableContainer, TableHead, TableRow,
  CircularProgress, Paper, Button,
  TableSortLabel, Snackbar, IconButton, Backdrop
} from "@mui/material";

import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

import {
  TableButton,
  StyledTableRow,
  StyledTableCell,
  StyleTableSortLabel,
} from "../../SXStyle";

import {
  asignarLicencia,
  verLicenciaEspecifica,
} from "../../service/apiService";


import { useAppDispatch, useAppSelector } from "../../provider/app/hooks";
import { setItems as setLicenseItem } from "../../provider/Slice/LicenceSlice";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMainLicense({ open, setOpen, registro = null, setSnackbar }) {
  const dispatch = useAppDispatch();
  const usuarios = useAppSelector((state) => state.StoreUsuarios.data);
  const cacheUsuario = JSON.parse(localStorage.getItem("sesionIniciada"));

  const [data, setData] = useState([]);

  //order columns
  const [order, setOrder] = useState("asc"); // "asc" o "desc"
  const [orderBy, setOrderBy] = useState("type"); // columna ordenada

  //loader
  const [openLoader, setOpenLoader] = useState(true);

  //licencias
  const [licenciasAsignadas, setLicenciasAsignadas] = useState([]);

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedData = React.useMemo(
    () => [...(data || [])].sort(getComparator(order, orderBy)),
    [data, order, orderBy]
  );

  useEffect(() => {
    loadData();
  }, [registro]);

  //carga las licencias asignadas y el listado de usuarios
  const loadData = async() => {
    try
    {
      setOpenLoader(true);

      if (registro !== null) 
      {
        await verLicenciasAsignadas(registro.id);
        setData(usuarios);
      }
    }
    catch(ex)
    {
      console.log("ex")
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  }

  //ve las licencias que tiene el registro seleccionado
  const verLicenciasAsignadas = async (id) => {
    const response = await verLicenciaEspecifica(id);
    setLicenciasAsignadas(response.data);
  };

  const recuperarLicenciaUsuario = (idUsuario) => {
    if (licenciasAsignadas.length > 0) {
      let result = licenciasAsignadas.filter(
        (item) => item.user === idUsuario && item.license === registro.id
      );
      return result.length > 0;
    }
    return false;
  };

  //asigna o quita licencia dado el caso
  const asignarLicenciaUsuario = async (idUsuario) => {
    try 
    {
      setOpenLoader(true);

      let dataToSend = {
        user: idUsuario,
        license: registro.id,
        status: 1,
        assigned_by: cacheUsuario.id,
      };
      const response = await asignarLicencia(dataToSend);
      setSnackbar({ message: response?.message, open: true });

      //recarga todo el listado de licencias
      dispatch(setLicenseItem(response.data));

      //recarga el listado de licencia especifica
      await verLicenciasAsignadas(registro.id);
    } 
    catch (ex) {
      console.log({ ex });
      setSnackbar({
        message: "Algo ha salido mal , intentelo de nuevo",
        open: true,
      });
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  };

  return (
    <React.Fragment>
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
          },
        }}
      >
        <DialogTitle>
          <p className="text-white font-bold">
            Detalles de la Licencia "{registro?.name}"
          </p>
        </DialogTitle>

        <DialogContent>
          {/* Tabla */}
            <div>
              {openLoader ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <CircularProgress sx={{ color: "#cc9737" }} />
                </div>
              ) : (
                <TableContainer
                    component={Paper}
                    sx={{ maxHeight: "350px", width: "100%", marginTop: "20px" }}
                  >
                  <Table aria-label="customized table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          sortDirection={orderBy === "fullname" ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === "fullname"}
                            direction={orderBy === "fullname" ? order : "asc"}
                            onClick={() => handleRequestSort("fullname")}
                            sx={{ ...StyleTableSortLabel, width: "250px" }}
                          >
                            <p className="ml-8"> Usuario </p>
                          </TableSortLabel>
                        </StyledTableCell>

                        <StyledTableCell></StyledTableCell>

                        <StyledTableCell
                          align="center"
                          sortDirection={orderBy === "fullname" ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === "fullname"}
                            direction={orderBy === "fullname" ? order : "asc"}
                            onClick={() => handleRequestSort("fullname")}
                            sx={StyleTableSortLabel}
                          >
                            Reservado
                          </TableSortLabel>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {sortedData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">
                            <div>
                              <p>{row.fullname}</p>
                              <p className="text-blue-500">
                                {" <" + row.email + " >"}
                              </p>
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            <div className="flex">
                              <RadioButtonCheckedIcon
                                className={
                                  row.status == "1"
                                    ? "text-verde"
                                    : "text-amarillo"
                                }
                              />
                              <p className="ml-3 mt-1">
                                {row.status ? "Activo" : "Inactivo"}
                              </p>
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            <Button
                              variant="contained"
                              sx={{
                                ...TableButton,
                                color: "white",
                                backgroundColor: recuperarLicenciaUsuario(row.id)
                                  ? "green"
                                  : "gray",
                              }}
                              onClick={() => asignarLicenciaUsuario(row.id)}
                            >
                              Reservar
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cerrar </p>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogMainLicense;
